module.exports = __webpack_public_path__ + "static/media/compDashboardActive.9c2c7c0e.png";